module.exports = __webpack_public_path__ + "bd271c4283ad8aa0d51297822fbac941.pdf";